import { render, staticRenderFns } from "./AuthBar.vue?vue&type=template&id=4a6c62a2&scoped=true&"
import script from "./AuthBar.vue?vue&type=script&lang=js&"
export * from "./AuthBar.vue?vue&type=script&lang=js&"
import style0 from "./AuthBar.vue?vue&type=style&index=0&id=4a6c62a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c62a2",
  null
  
)

component.options.__file = "AuthBar.vue"
export default component.exports